import ProduttivoMuiTheme from '@/javascript/presentation/theme/produttivo-mui-theme'

const primaryColor = ProduttivoMuiTheme.palette.primary.main

export const palette = Array.from({ length: 100 }, (_, i) => ({
  color: i === 0 ? primaryColor : `hsl(${(135 + i * 137.508) % 360}, 70%, 45%)`,
  textColor: '#fff',
}))
